<template>
  <div>
    <h3>
      Welcome to Student Storage!
    </h3>

    <div class="mb-4"/>

    <div class="row mb-4">
      <div class="col-12 col-md-6">
        <ProductCard
          :title="products.student_vault_extended_storage.title"
          :price="products.student_vault_extended_storage.price_for_display"
          :is-active="true"
        >
          <template #description>
            <span v-html="products.student_vault_extended_storage.description"/>
          </template>

          <template #actions>
            <b-form-radio
              v-model="formData.base_product.value"
              :value="products.student_vault_extended_storage.id"
            >
              SELECT
            </b-form-radio>

            <b-checkbox
                v-model="formData.declined_bags.value"
                :value="products.declined_bags.id"
                :unchecked-value="null"
            >
              I Don't Need Bags
            </b-checkbox>
          </template>
        </ProductCard>
      </div>
    </div>

    <section
      v-if="false"
      class="mb-4"
    >
      <header class="text-uppercase">
        <h4>Upgrade Your Storage Package</h4>
      </header>

      <p>
        Store additional items on top of the included 7 items in your student storage with one of our discounted packages
        or single item add ons. Discounted pricing only available at time of sign up
      </p>

      <b-radio-group v-model="formData.package_addon.value">
        <div class="mb-3">
          <b-form-radio
            value=""
          >
            NOT SELECTED
          </b-form-radio>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 mb-3">
            <ProductCard
              :title="products.extra_3_items_package_addon.title"
              :price="products.extra_3_items_package_addon.price_for_display"
              :is-active="formData.package_addon.value === products.extra_3_items_package_addon.id"
            >
              <template #description>
                <span v-html="products.extra_3_items_package_addon.description"/>
              </template>

              <template #actions>
                <b-form-radio
                  :value="products.extra_3_items_package_addon.id"
                >
                  SELECT
                </b-form-radio>
              </template>
            </ProductCard>
          </div>
          <div class="col-12 col-md-6 mb-3">
            <ProductCard
              :title="products.extra_5_items_package_addon.title"
              :price="products.extra_5_items_package_addon.price_for_display"
              :is-active="formData.package_addon.value === products.extra_5_items_package_addon.id"
            >
              <template #description>
                <span v-html="products.extra_5_items_package_addon.description"/>
              </template>

              <template #actions>
                <b-form-radio
                  :value="products.extra_5_items_package_addon.id"
                >
                  SELECT
                </b-form-radio>
              </template>
            </ProductCard>
          </div>
        </div>
      </b-radio-group>
    </section>

    <div class="mb-4">
      <div class="row">
        <div class="col-12 col-md-6 mb-4">
          <ProductCard
            :title="products.vault_items.title"
            :price="products.vault_items.price_for_display"
          >
            <template #teaser>
              <span v-html="products.vault_items.teaser"/>
            </template>

            <template #description>
              <span v-html="products.vault_items.description"/>
            </template>

            <template #actions>
              <ControlQuantity
                v-model="formData.vault_items.value"
                :min="1"
              />
            </template>
          </ProductCard>
        </div>

        <div class="col-12 col-md-6 mb-4">
          <ProductCard
            :title="products.additional_bags.title"
            :price="products.additional_bags.price_for_display"
          >
            <template #teaser>
              <span v-html="products.additional_bags.teaser"/>
            </template>

            <template #description>
              <span v-html="products.additional_bags.description"/>
            </template>

            <template #actions>
              <ControlQuantity
                v-model="formData.additional_bags.value"
                :min="0"
              />
            </template>
          </ProductCard>
        </div>
      </div>
    </div>

    <section>
      <h3>
        Luxury Mattress Topper Program
      </h3>

      <div class="row">
        <div class="col-12 col-md-7 mb-3">
          <p>
            Start your school year off on the right track with our luxury mattress toppers designed
            specifically for UChicago dorm room beds. You'll get the perfect fit and premium
            comfort all delivered to your room prior to your Fall arrival!
          </p>
          <p>
            All of our toppers are made from 4lb. density visco-elastic memory foam, a hypoallergenic
            material that provides temperature-sensitive comfort and are made in the USA.
          </p>
        </div>
        <div class="col-12 col-md-5 mb-3">
          <img
            src="/assets/uchicago/iStock-1171100714.webp"
            class="img-fluid rounded opacity-80"
          >
        </div>
      </div>


      <b-radio-group>
        <div class="mb-3">
          <b-form-radio
            v-model="formData.mattress_topper.value"
            :value="null"
          >
            NOT SELECTED
          </b-form-radio>
        </div>

        <div class="row">
          <div class="col-12 col-md-4 mb-4">
            <ProductCard
              :title="products.mattress_toppers.comfort.title"
              :price="products.mattress_toppers.comfort.price_for_display"
              :is-active="formData.mattress_topper.value === products.mattress_toppers.comfort.id"
            >
              <template #description>
                <span v-html="products.mattress_toppers.comfort.description"/>
              </template>

              <template #teaser>
                <span v-html="products.mattress_toppers.comfort.teaser"/>
              </template>

              <template #actions>
                <b-form-radio
                  v-model="formData.mattress_topper.value"
                  :value="products.mattress_toppers.comfort.id"
                >
                  SELECT
                </b-form-radio>
              </template>
            </ProductCard>
          </div>

          <div class="col-12 col-md-4 mb-4">
            <ProductCard
              :title="products.mattress_toppers.comfort_plus.title"
              :price="products.mattress_toppers.comfort_plus.price_for_display"
              :is-active="formData.mattress_topper.value === products.mattress_toppers.comfort_plus.id"
            >
              <template #description>
                <span v-html="products.mattress_toppers.comfort_plus.description"/>
              </template>

              <template #teaser>
                <span v-html="products.mattress_toppers.comfort_plus.teaser"/>
              </template>

              <template #actions>
                <b-form-radio
                  v-model="formData.mattress_topper.value"
                  :value="products.mattress_toppers.comfort_plus.id"
                >
                  SELECT
                </b-form-radio>
              </template>
            </ProductCard>
          </div>

          <div class="col-12 col-md-4 mb-4">
            <ProductCard
              :title="products.mattress_toppers.luxe.title"
              :price="products.mattress_toppers.luxe.price_for_display"
              :is-active="formData.mattress_topper.value === products.mattress_toppers.luxe.id"
            >
              <template #description>
                <span v-html="products.mattress_toppers.luxe.description"/>
              </template>

              <template #teaser>
                <span v-html="products.mattress_toppers.luxe.teaser"/>
              </template>

              <template #actions>
                <b-form-radio
                  v-model="formData.mattress_topper.value"
                  :value="products.mattress_toppers.luxe.id"
                >
                  SELECT
                </b-form-radio>
              </template>
            </ProductCard>
          </div>
        </div>
      </b-radio-group>
    </section>

    <CollegeStorageNavigation
      :show-back-button="!$store.state.collegeStorage.isUserInfoFormPrefilled"
      @back-button-clicked="handleGoBack"
      @next-button-clicked="handleContinue"
    />
  </div>
</template>

<script lang="ts">
import ControlInput from "@app-components/controls/control-input.vue";
import ControlQuantity from "@app-components/controls/control-quantity.vue";
import ControlCheckbox from "@app-components/controls/control-checkbox.vue";
import CollegeStorageNavigation from "js/UI/CollegeStorage/Navigation.vue";
import Vue from "vue";
import {Component} from "vue-property-decorator";
import ProductCard from "@/UI/CollegeStorage/ProductCard.vue";
import {OrderPositionsFormData} from "@/UI/stores/college-storage";

interface StudentVaultProductInfo {
  id?: string;
  title: string | null;
  teaser?: string;
  description: string | null;
  price_for_display: string;
  price_for_calculation: number;
}

@Component({
  components: {ProductCard, CollegeStorageNavigation, ControlCheckbox, ControlQuantity, ControlInput}
})
export default class CollegeStorage_StorageOptions extends Vue {

  products = new class {
    /*
    student_vault_membership: StudentVaultProductInfo = {
      id: "student_vault_membership",
      title: "Student Vault Membership",
      description: `Store Up to 7 Items<br/> Includes 4 Blue Crates Storage Bags`,
      price_for_display: "$400",
      price_for_calculation: 400
    };

    student_vault_extended_storage: StudentVaultProductInfo = {
      id: "student-vault-2023-extended-storage",
      title: "Winter Storage Package",
      description: `Pickup & Delivery INCLUDED<br/> Includes 4 complimentary Blue Crates storage bags (Storage of the bag(s) not included. These are yours to keep and use at your discretion)`,
      price_for_display: "Enrollment Fee $150",
      price_for_calculation: 150
    };
    */

    student_vault_extended_storage: StudentVaultProductInfo = {
      id: "student-vault-2024-spring-storage-package",
      title: "Spring Storage Package",
      description: `Pickup & Delivery INCLUDED<br/> Includes 4 complimentary Blue Crates storage bags (Storage of the bag(s) not included. These are yours to keep and use at your discretion)`,
      price_for_display: "Enrollment Fee $180",
      price_for_calculation: 180
    };

    declined_bags: StudentVaultProductInfo = {
      id: "student-vault-2024-declined-bags",
      title: null,
      description: null,
      price_for_display: "-",
      price_for_calculation: 0
    };

    extra_3_items_package_addon: StudentVaultProductInfo = {
      id: "student-vault-2023-extra-3-items",
      title: "Store Extra 3 Items",
      description: `Add 3 More Items to your Student Storage`,
      price_for_display: "$165",
      price_for_calculation: 165
    };

    extra_5_items_package_addon: StudentVaultProductInfo = {
      id: "student-vault-2023-extra-5-items",
      title: "Store Extra 5 Items",
      description: `Add 5 More Items to your Student Storage`,
      price_for_display: "$250",
      price_for_calculation: 250
    };

    vault_items: StudentVaultProductInfo = {
      id: "student-vault-2023-extended-storage-vault-item",
      title: "Vault Items",
      teaser: `Storage is purchased on a per-item basis in addition to the Enrollment Fee. A minimum of 1 item must be added to your order.`,
      description: ``,
      price_for_display: "$35/each",
      price_for_calculation: 35
    };

    additional_bags: StudentVaultProductInfo = {
      id: "additional_bags",
      title: "Additional Bags",
      teaser: `All bags will be distributed during on campus label and bag distribution dates`,
      description: `Pack of 4`,
      price_for_display: "$24/each",
      price_for_calculation: 24
    };

    mattress_toppers = new class {
      comfort: StudentVaultProductInfo = {
        id: "student-vault-2023-mattress-topper-comfort",
        title: "Comfort",
        teaser: `2” 4lbs. Mattress topper`,
        description: `Our standard mattress topper is made from pure memory foam with better performance in softness and support,
        is hypoallergenic and provides temperature-sensitive comfort. This mattress topper has a medium-feel firmness and is
        our most economical option.`,
        price_for_display: "$95",
        price_for_calculation: 95
      };

      comfort_plus: StudentVaultProductInfo = {
        id: "student-vault-2023-mattress-topper-comfort-plus",
        title: `Comfort <span class="blue-text">Plus</span>`,
        teaser: `3” 4lbs. Mattress topper`,
        description: `Our comfort plus option has all the benefits of our standard option, but with just enough added memory foam to provide
        that extra level of plushness, naturally contouring to your body reducing any aches and pains.`,
        price_for_display: "$140",
        price_for_calculation: 140
      };

      luxe: StudentVaultProductInfo = {
        id: "student-vault-2023-mattress-topper-luxe",
        title: "Luxe",
        teaser: `4” 4lbs Mattress topper`,
        description: `For those that are only satisfied with the best, we offer our luxe option. Double the memory foam from our standard topper.
        With the pressure relieving comfort, you'll enjoy a cloud-like slumber and are sure to be well-rested and energized in the morning.`,
        price_for_display: "$180",
        price_for_calculation: 180
      };
    };
  };

  formData: OrderPositionsFormData = this.$store.state.collegeStorage.orderPositions;

  created() {
    this.formData.base_product.value = this.products.student_vault_extended_storage.id;
  }

  handleGoBack() {
    this.$emit('back-button-clicked');
  }

  handleContinue() {
    this.$store.dispatch('collegeStorage/loadDeliveryDates', this.$store.state.collegeStorage.userFormData.partner_building_id.value);
    this.$store.dispatch("collegeStorage/refreshCheckout");

    this.$emit('next-button-clicked');
  }
}
</script>

<style scoped lang="scss">
</style>
